import { Link } from 'react-router-dom';

interface VideoCardProps {
  id: number;
  title: string;
  cover: string;
  rating: number;
  year: number;
  duration: string;
  tags: string[];
  source: string;
  category: string;
  isHot?: boolean;
  isNew?: boolean;
  views: string;
}

export default function VideoCard({
  id,
  title,
  cover,
  rating,
  year,
  duration,
  tags,
  source,
  category,
  isHot,
  isNew,
  views,
}: VideoCardProps) {
  return (
    <div className="group cursor-pointer" data-product-shop>
      <div className="relative overflow-hidden rounded-lg aspect-video mb-3 bg-background-200">
        <img
          src={cover}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          title={title}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>

        {isHot && (
          <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-500 text-white text-xs font-semibold">
            热播
          </span>
        )}
        {isNew && (
          <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-accent-500 text-white text-xs font-semibold">
            新上
          </span>
        )}

        <div className="absolute bottom-0 left-0 right-0 p-3 flex items-end justify-between">
          <div className="flex items-center gap-1 text-white text-xs">
            <i className="ri-star-fill text-accent-400 text-xs"></i>
            <span>{rating}</span>
          </div>
          <span className="text-white/80 text-xs">{views}次观看</span>
        </div>

        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
            <i className="ri-play-fill text-white text-2xl ml-0.5"></i>
          </div>
        </div>
      </div>

      <Link
        to={`/category/${category}`}
        className="block"
      >
        <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors mb-1">
          {title}
        </h3>
      </Link>

      <div className="flex items-center gap-2 text-xs text-foreground-500 mb-1.5 flex-wrap">
        <span>{year}</span>
        <span className="text-foreground-300">|</span>
        <span>{duration}</span>
        <span className="text-foreground-300">|</span>
        <span className="text-primary-600">{source}</span>
      </div>

      <div className="flex items-center gap-1.5 flex-wrap">
        {tags.slice(0, 2).map((tag) => (
          <span
            key={tag}
            className="px-2 py-0.5 rounded-md text-xs bg-secondary-100 text-secondary-700 whitespace-nowrap"
          >
            {tag}
          </span>
        ))}
      </div>
    </div>
  );
}